module.exports = __webpack_public_path__ + "img/username.560f1fbb.png";